<template>
  <v-container class="my-12 footer" fluid ref="contactUs">
    <v-row
      id="contactUs"
      no-gutters
      class="flex-column flex-md-row flex-lg-row flex-xl-row justify-lg-space-around justify-md-space-around"
    >
      <v-col md="4" lg="4" xl="4" class="mt-2">
        <v-img
          :src="require(`../assets/merlocode-textonly.png`)"
          height="30px"
          width="200px"
          contain
        />

        <div class="body-1 my-4 mx-4">
          Ofrece un mejor servicio a tus clientes y simplifica la gestión de tu
          carta y pedidos digitalmente.
        </div>
        <div class="d-flex justify-start">
          <v-btn
            outlined
            color="primary"
            elevation="0"
            class="mx-4 my-4"
            @click="goToMerloCodeSignUp()"
          >
            <span>Regístrate en MerloCode</span>
          </v-btn>
        </div>
      </v-col>
      <v-col lg="4" md="4" class="mt-3">
        <h3 class="headline mx-4">¿Tienes alguna pregunta?</h3>
        <v-row
          no-gutters
          class="flex-column flex-md-row flex-lg-row flex-xl-row justify-lg-center justify-md-center"
        >
          <v-col>
            <v-text-field
              v-model="email"
              label="e-mail"
              :error-messages="errors.email"
              outlined
              @keypress="removeErrors('email')"
              class="mt-5 mr-md-5 mr-lg-5 mr-xl-5 mx-4"
            />
            <v-textarea
              name="input-7-4"
              label="Escribe una pregunta..."
              :error-messages="errors.question"
              v-model="question"
              outlined
              @keypress="removeErrors('question')"
              class="mx-4"
            />
            <v-btn outlined color="primary" elevation="0" @click="sendQuestion" class="mx-4">
              <span>Enviar</span>
            </v-btn>o llámanos al 644 50 91 26
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="d-flex justify-start align-end">
      <v-btn text elevation="0" class @click="goToMerloCodeLegal()">
        <span>AVISO LEGAL Y CONDICIONES DE USO</span>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { firestore } from "../firebase/firestore";

export default {
  name: "Footer",
  data: () => {
    return { email: "", question: "", errors: { email: "", question: "" } };
  },

  methods: {
    removeErrors(field) {
      delete this.errors[field];
      this.errors = { ...this.errors };
    },

    isValidEmail() {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailRegex.test(this.email)) {
        this.errors = { ...this.errors, email: "Introduce un email válido" };
        return false;
      }
      return true;
    },

    isValidQuestion() {
      if (!this.question) {
        this.errors = {
          ...this.errors,
          question: "El mensaje no puede estar vacío"
        };
        return false;
      }
      return true;
    },

    async sendQuestion() {
      let question = {
        email: this.email,
        question: this.question
      };
      if (this.isValidEmail() & this.isValidQuestion()) {
        await firestore
          .collection("feedback")
          .doc()
          .set(question);
        this.email = "";
        this.question = "";
      }
    },

    goToMerloCodeSignUp() {
      console.log(`go to https://admin.merlocode.com/signup`);
      window.document.location = "https://admin.merlocode.com/signup";
    },
    goToMerloCodeLegal() {
      console.log(`go to https://merlocode.com/legal`);
      window.document.location = "https://merlocode.com/legal";
    }
  }
};
</script>

<style>
.footer {
  color: black;
}
</style>
